<template>
  <div id="app">
    <GameHeader />
    <main class="game-content">
      <aside class="game-content__sidebar game-content__sidebar--left">
        <HorseList />
      </aside>
      <section class="game-content__main">
        <RaceTrack />
      </section>
      <aside class="game-content__sidebar game-content__sidebar--right">
        <div class="game-content__panels">
          <RaceProgram />
          <RaceResults />
        </div>
      </aside>
    </main>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import GameHeader from './components/GameHeader.vue'
import HorseList from './components/HorseList.vue'
import RaceTrack from './components/RaceTrack.vue'
import RaceProgram from './components/RaceProgram.vue'
import RaceResults from './components/RaceResults.vue'

export default {
  name: 'App',
  components: { GameHeader, HorseList, RaceTrack, RaceProgram, RaceResults },
  setup() {
    const store = useStore()
    onMounted(() => store.dispatch('horses/generateHorses'))
    return {}
  }
}
</script>

<style>
:root {
  --color-primary: #6366f1;
  --color-primary-hover: #4f46e5;
  --color-primary-light: #e0e7ff;
  
  --color-secondary: #10b981;
  --color-secondary-hover: #059669;
  --color-secondary-light: #d1fae5;
  
  --color-warning: #f59e0b;
  --color-warning-hover: #d97706;
  --color-warning-light: #fef3c7;
  
  --color-bg: #f8fafc;
  --color-bg-card: #ffffff;
  --color-border: #e2e8f0;
  --color-border-light: #f1f5f9;
  --color-text: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-muted: #94a3b8;
  
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  
  --radius-sm: 6px;
  --radius: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'JetBrains Mono', 'Fira Code', monospace;
  
  --header-height: 64px;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

body {
  background-color: var(--color-bg);
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.game-content {
  display: grid;
  grid-template-columns: 280px 1fr 520px;
  gap: var(--space-5);
  padding: var(--space-5);
  height: calc(100vh - var(--header-height));
  overflow: hidden;
}

.game-content__sidebar--left {
  height: 100%;
  overflow: hidden;
}

.game-content__sidebar--right {
  height: 100%;
  overflow: hidden;
}

.game-content__main {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.game-content__panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
  height: 100%;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-muted);
}

@media (max-width: 1400px) {
  .game-content {
    grid-template-columns: 1fr;
    height: auto;
    overflow: auto;
  }
  
  .game-content__panels {
    grid-template-columns: 1fr 1fr;
    height: auto;
  }
}

@media (max-width: 768px) {
  .game-content__panels {
    grid-template-columns: 1fr;
  }
}
</style>
